export {default} from './UsersListModel';
export {UsersListModelType} from './UsersListModel';



// WEBPACK FOOTER //
// ./src/models/UsersListModel/index.ts